import { AutogenModelEdiBillingDetail, AutogenRowEdiBillingDetail } from "./autogen/AutogenModelEdiBillingDetail";

export class ModelEdiBillingDetail extends AutogenModelEdiBillingDetail<RowEdiBillingDetail> {
	constructor() {
		super(RowEdiBillingDetail);
	}
}

export class RowEdiBillingDetail extends AutogenRowEdiBillingDetail {
}